"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionaryEntrySchema = void 0;
const zod_1 = require("zod");
const language_1 = require("./language");
// TranslationSchema
const TranslationSchema = zod_1.z.object({
    _id: zod_1.z.string().optional(),
    word: zod_1.z.string(),
    partOfSpeech: zod_1.z.string(),
    gender: zod_1.z.string(),
    exampleInput: zod_1.z.string(),
    exampleInputAudioURL: zod_1.z.string().optional(),
    exampleOutput: zod_1.z.string(),
    exampleOutputAudioURL: zod_1.z.string().optional(),
    frequency: zod_1.z.string(),
});
// WordInfoSchema
const WordInfoSchema = zod_1.z.object({
    _id: zod_1.z.string().optional(),
    wordPosition: zod_1.z.number(),
    wordFrequencyNumber: zod_1.z.number(),
    wordFrequencyPercentage: zod_1.z.number(),
    lemma: zod_1.z.string(),
    lemmaPosition: zod_1.z.number(),
    percentage: zod_1.z.number(),
    levels: zod_1.z.object({
        confident: zod_1.z.string(),
        oxford: zod_1.z.string(),
        milton: zod_1.z.string(),
    }),
});
exports.dictionaryEntrySchema = zod_1.z.object({
    _id: zod_1.z.string().optional(),
    word: zod_1.z.string(),
    audioURL: zod_1.z.string().optional(),
    language: language_1.languageISO3Schema,
    gender: zod_1.z.string().optional().nullable(),
    partOfSpeech: zod_1.z.string().optional().nullable(),
    translations: zod_1.z.array(zod_1.z.object({
        language: language_1.languageISO3Schema,
        words: zod_1.z.array(TranslationSchema),
    })),
    encounters: zod_1.z.number(),
    wordInfo: WordInfoSchema,
});
//# sourceMappingURL=dictionary.js.map